import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export const intervalStatusTypes = {
  base: 'base',
  baseInverted: 'base-inverted',
};

const IntervalStatusContainer = ({
  type,
  className,
  bordered = false,
  ...props
}) => {
  return (
    <div
      {...props}
      data-type={type}
      className={cn(styles.root, className, { [styles.bordered]: bordered })}
    />
  );
};

export default IntervalStatusContainer;
